var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_0_logo_F4L_CB_white",
    "data-name": "0_logo_F4L+CB_white",
    xmlns: "http://www.w3.org/2000/svg",
    width: 140,
    height: 40,
    viewBox: "0 0 268 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_793",
    "data-name": "Group 793",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2100",
    "data-name": "Path 2100",
    d: "M212.259,776.573H188.7v17.038h-7.293V771.074c0-8.25,1.315-11.658,5.62-14.707,3.049-1.973,6.337-2.69,12.554-2.63h12.674v5.978H199.764c-7.592-.119-10.94,2.511-11.06,8.669V770.6h23.554Z",
    transform: "translate(-181.411 -753.733)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2101",
    "data-name": "Path 2101",
    d: "M401.627,753.754h6.755v6.815h-6.755Zm6.755,10.761v29.114h-6.755V764.515Z",
    transform: "translate(-365.578 -753.751)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2102",
    "data-name": "Path 2102",
    d: "M479.255,753.754h6.755v10.761h8.071v5.321H486.01v13.152c-.06,4.424.658,5.261,4.783,5.321h3.288v5.321h-5.739c-6.7.12-9.206-2.571-9.087-9.745V769.836h-5.321v-5.321h5.321Z",
    transform: "translate(-426.049 -753.751)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_794",
    "data-name": "Group 794",
    transform: "translate(71.08 0.003)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2103",
    "data-name": "Path 2103",
    d: "M615.629,778.624l22.837-24.87h10.342V779.4h5.62v5.978h-5.62v8.25h-7.293v-8.25H615.629Zm25.886.777V759.852L623.58,779.4Z",
    transform: "translate(-615.629 -753.754)",
    fill: "#1ba8f2"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_795",
    "data-name": "Group 795",
    transform: "translate(115.378 0.003)",
    style: {
      mixBlendMode: "normal",
      isolation: "isolate"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2104",
    "data-name": "Path 2104",
    d: "M893.533,753.754v22.837c.12,5.62.538,7.413,1.913,8.788,1.614,1.554,4.544,2.332,8.728,2.272h8.369v5.978H903.1c-7.174-.06-9.685-.717-13.032-3.587-2.81-2.69-3.766-5.859-3.826-13.033V753.754Z",
    transform: "translate(-886.24 -753.754)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2105",
    "data-name": "Path 2105",
    d: "M1073.222,753.754h6.755v6.815h-6.755Zm6.755,10.761v29.114h-6.755V764.515Z",
    transform: "translate(-1042.614 -753.754)",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2106",
    "data-name": "Path 2106",
    d: "M1164.928,819.491h7.174L1159.069,848.6h-6.457l-12.2-29.114h7.413l8.25,20.924Z",
    transform: "translate(-1098.809 -808.73)",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2107",
    "data-name": "Path 2107",
    d: "M1360.268,753.754h6.755v6.815h-6.755Zm6.755,10.761v29.114h-6.755V764.515Z",
    transform: "translate(-1282.671 -753.754)",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2108",
    "data-name": "Path 2108",
    d: "M1465.549,819.457c8.13-.179,11.717,3.288,11.717,11.538v17.576h-6.755v-17.7c0-4.424-1.614-6.158-5.679-6.1h-6.875v23.794H1451.2V819.457Z",
    transform: "translate(-1358.719 -808.696)",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2109",
    "data-name": "Path 2109",
    d: "M1673.82,846.692c-.06,5.739-.359,7.114-1.793,8.908-1.853,2.092-4.244,2.75-9.685,2.75h-13.989v-5.321H1662.4c4.125,0,4.723-.538,4.663-4.424h-6.756c-5.081,0-7.233-.538-9.744-2.391-3.348-2.451-5.082-6.516-5.082-11.837,0-4.9,1.554-9.087,4.424-11.717,2.571-2.391,5.2-3.169,10.582-3.169h13.332Zm-12.913-21.881c-3.527,0-5.38.717-6.7,2.511-1.076,1.495-1.734,4.245-1.734,7.114a10.567,10.567,0,0,0,1.973,6.636c1.315,1.554,3.049,2.212,6.1,2.212h6.516V824.812Z",
    transform: "translate(-1521.198 -808.73)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWhite);
export default __webpack_public_path__ + "static/media/logo_white.7805bffbdc5bcd0161c73d605dd37220.svg";
export { ForwardRef as ReactComponent };